<template>
  <el-dialog
    :title="$t('reportCustomComponentManage.confirmOperation')"
    :visible.sync="dialogVisible"
    width="30%"
    @close="handleClose"
  >
    <div style="text-align:center;">
      <p>{{ $t('reportCustomComponentManage.confirmDeleteComponent') }}</p>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">
        {{ $t('reportCustomComponentManage.cancel') }}
      </el-button>
      <el-button type="primary" @click="deleteReportCustomComponent" :loading="loading">
        {{ $t('reportCustomComponentManage.confirmDelete') }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { deleteReportCustomComponent } from '@/api/dev/reportCustomComponentApi'

export default {
  name: 'DeleteReportCustomComponent',
  data() {
    return {
      dialogVisible: false,
      deleteReportCustomComponentInfo: {},
      loading: false
    }
  },
  methods: {
    open(row) {
      this.deleteReportCustomComponentInfo = { ...row }
      this.dialogVisible = true
    },
    handleClose() {
      this.deleteReportCustomComponentInfo = {}
    },
    async deleteReportCustomComponent() {
      this.loading = true
      try {
        await deleteReportCustomComponent(this.deleteReportCustomComponentInfo)
        this.$message.success(this.$t('reportCustomComponentManage.deleteSuccess'))
        this.dialogVisible = false
        this.$emit('refresh')
      } catch (error) {
        console.error(error)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>